<template>
  <div :class="attachmentComponentClass">
    <div class="flex-row gap-xxs" style="margin-left: -8px">
      <dd-icon class="color-grey-less-transparent" icon="mdi mdi-paperclip" size="lg"/>
      <h3 class="color-grey-less-transparent m-0">Bijlagen</h3>
    </div>
    <div class="attachment-container container-xs flex-row flex-wrap align-items-center gap-sm border-radius-md">
      <div
        v-for="(attachment,index) in attachments"
        :key="index"
        class="flex-row align-items-center gap-xs bg-color-primary container-v-xxs container-h-xs"
        style="border-radius: 16px; padding-bottom: 2px; padding-top: 2px;"
      >
        <p
          class="color-white m-0 pressable"
          style="max-height: 21px"
          @click="showAttachment(attachment, index)"
        >
          {{attachment.filename}}
        </p>
        <dd-icon
          v-if="editable"
          icon="mdi mdi-close"
          size="md"
          class="color-white pressable"
          @click="removeAttachment(attachment)"
        />
      </div>

      <div
        v-for="(uploadedFile,index) in uploadedFiles"
        :key="'uploaded' + index"
        class="flex-row align-items-center gap-xs bg-color-primary container-v-xxs container-h-xs"
        style="border-radius: 14px"
      >
        <p
          class="color-white m-0 pressable"
          style="max-height: 21px"
          @click="showUploadedFile(index)"
        >
          {{uploadedFile.filename}}
        </p>
        <dd-icon
          v-if="editable"
          icon="mdi mdi-close"
          size="md"
          class="color-white pressable"
          @click="removeUploadedFile(index)"
        />
      </div>

      <div
        v-for="(document,index) in selectedDocuments"
        :key="'selected' + index"
        class="flex-row align-items-center gap-xs bg-color-primary container-v-xxs container-h-xs"
        style="border-radius: 14px"
      >
        <p
          class="color-white m-0"
          :class="{'pressable': document.display_link}"
          style="max-height: 21px"
          @click="showSelectedDocument(document)"
        >
          {{document.filename}}
        </p>
        <dd-icon
          v-if="editable"
          icon="mdi mdi-close"
          size="md" class="color-white pressable"
          @click="removeSelectedDocument(index)"
        />
      </div>
    </div>
    <dd-icon-button
        v-if="editable && customerId"
        icon="mdi mdi-file-search-outline"
        size="xl"
        @click="showDocumentSelectModal = true"
        data-dusk="search-document-button"
        title="Documenten selecteren"
    />
    <dd-icon-button
        v-if="editable"
        icon="mdi mdi-upload"
        size="xl"
        @click="showFilePicker"
        title="Bestand uploaden"
    />

    <input
        id="attachment-file-input"
        ref="fileInput"
        type="file"
        multiple
        @change="handleFileUpload"
        style="display: none"
    />

    <SelectDocumentModal
        v-if="customerId"
        :customer-id="customerId"
        :visible="showDocumentSelectModal"
        @cancel="showDocumentSelectModal = false"
        @input="handleDocumentSelect"
    />

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SelectDocumentModal from '~/pages/components/modal/SelectDocumentModal.vue'
import TemporaryFileApi from "~/api/temporaryFile";

export default {
  name: "AttachmentsComponent.vue",
  components:{
    SelectDocumentModal
  },
  props: {
    editable: {
      type: Boolean,
      required: false,
      default: false
    },
    value: {
      type: Object,
      required: false,
      default: () => ({uploadedFiles: [] })
    },
    customerId:{
      type: [String, Number]
    }
  },
  emits: ['change'],
  data(){
    return {
      showDocumentSelectModal: false
    };
  },
  methods:{
    showAttachment(attachment) {
      if (attachment.display_link) {
        this.navigator.openPath(this.route('email.view.attachment', [this.firstSelectedEmail.id, attachment.index]));
      }
    },
    removeAttachment(attachment){
      const attachmentIndex = this.firstSelectedEmail.attachments.findIndex((att) => att.index === attachment.index);
      this.firstSelectedEmail.attachments.splice(attachmentIndex, 1);
    },
    showFilePicker(){
      this.$refs.fileInput.click();
    },
    showUploadedFile(index){
      this.navigator.openPath(`/temporary_file/${this.uploadedFiles[index].uuid}`);
    },
    removeUploadedFile(index){
      this.uploadedFiles.splice(index, 1);
    },
    async handleFileUpload(e){
      const files = [...e.target.files];
      const uploadedFiles = await Promise.all(files.map( async (file) => {
        return await TemporaryFileApi.uploadTemporaryFile( file );
      }));
      this.$set(this, 'uploadedFiles', [ ...this.uploadedFiles, ...uploadedFiles ]);
      e.target.value = null;
    },
    handleDocumentSelect(documents){
      this.$set(this, 'selectedDocuments', [ ...this.selectedDocuments, ...documents ]);
      this.showDocumentSelectModal = false;
    },
    showSelectedDocument(document){
      if (document.display_link) {
        this.navigator.openPath(document.display_link);
      }
    },
    removeSelectedDocument(index){
      this.selectedDocuments.splice(index, 1);
    },
  },
  computed: {
    ...mapGetters('email', [
      "firstSelectedEmail"
    ]),
    attachments(){
      return this.firstSelectedEmail?.attachments.filter(attachment => attachment.inline === false) || [];
    },
    attachmentComponentClass(){
      return (this.attachments.length > 0 || this.editable) ? 'pb-sm container-h-md flex-row align-items-center gap-sm' : 'hide';
    },
    uploadedFiles: {
      get()  {
        return this.value?.uploaded;
      },
      set(value)  {
        this.$emit('input', {...this.value, uploaded: value});
      },
    },
    selectedDocuments: {
      get()  {
        return this.value?.selected;
      },
      set(value)  {
        this.$emit('input', {...this.value, selected: value});
      },
    }
  },
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
.attachment-container{
  border: 1px solid $color-grey-less-transparent;
  min-height: $spacing-xl;
}
</style>
